// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/js/async/" + chunkId + "." + {"534": "5f58ff21","728": "483a09d8",}[chunkId] + ".js"
}